import React, {
  ReactElement,
} from 'react';
import {Stack, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import {CancelRounded, CheckCircleRounded} from "@mui/icons-material";


export const Item = ({
                              name,
                       value,
                       direction,
                       titleWidth,
                       type,
                            }: {
  name: any;
  value: any;
  direction?: any;
  titleWidth?: any;
  type?: any;
}): ReactElement => {

  return (
    <Stack
      direction={direction || 'column'}
      gap={1}
      alignContent={'center'}
      sx={{
        width: '100%',
        marginY: '2px',
        background: '#fff',
        boxShadow: '0px 2px 5px -1px #00000017',
        borderRadius: '10px',
        padding: '15px'
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          width: `${titleWidth || 150}px`,
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight={'bold'}
        >
          {name}:
        </Typography>
      </Box>
      <Stack
        sx={{
          width: '100%',
          '& svg': {
            height: '30px',
            width: '30px',
            display: 'inline-block'
          }
        }}
        alignItems={'flex-start'}
        justifyContent={'center'}
      >
        {type ? (
          <>
            {type === 'checkbox' && (
              <>
                {value ? (
                  <CheckCircleRounded color={'success'} />
                ) : (
                  <CancelRounded color={'error'} />
                )}
              </>
            )}
          </>
        ): (
          <div dangerouslySetInnerHTML={{__html: value}}></div>
        )}
      </Stack>
    </Stack>
  );
};
